import { render, staticRenderFns } from "./FmPage.vue?vue&type=template&id=1f7820a0&scoped=true&"
import script from "./FmPage.vue?vue&type=script&lang=js&"
export * from "./FmPage.vue?vue&type=script&lang=js&"
import style0 from "./FmPage.vue?vue&type=style&index=0&id=1f7820a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7820a0",
  null
  
)

export default component.exports